module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/outlets/outlets.component.css
// module id = ./src/app/outlets/outlets.component.css
// module chunks = main